<main class="main" *ngIf="isAdmin">
  <div>
    <div class="flex-container">
      <h1 class="title"> {{'administration.users' | transloco }}</h1>
      <button (click)="adduser()" class="add-button">{{'administration.addUser' | transloco }}</button>
    </div>
    <hr/>
    <div class="content">
      <table>
        <thead>
          <tr>
            <th class="row-delete"></th>
            <th style="border-left: none">{{'administration.user' | transloco }}</th>
            <th>{{'administration.role' | transloco }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of users" (click)="selectUser(user)">
            <td class="row-delete">
              <svg style="cursor: pointer" (click)="deleteUser(user)" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <rect width="32" height="32" rx="16" fill="#EAE4FF" />
                <path d="M18.6667 10.6667V9.33333C18.6667 8.97971 18.5262 8.64057 18.2761 8.39052C18.0261 8.14048 17.687 8 17.3333 8H13.3333C12.9797 8 12.6406 8.14048 12.3905 8.39052C12.1405 8.64057 12 8.97971 12 9.33333V10.6667" stroke="#7855ED" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M22.6667 10.666H8" stroke="#7855ED" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M21.333 10.666V23.3327C21.333 23.5095 21.2628 23.6791 21.1377 23.8041C21.0127 23.9291 20.8432 23.9993 20.6663 23.9993H9.99967C9.82286 23.9993 9.65329 23.9291 9.52827 23.8041C9.40325 23.6791 9.33301 23.5095 9.33301 23.3327V10.666" stroke="#7855ED" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13.333 14.666V19.9993" stroke="#7855ED" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M17.333 14.666V19.9993" stroke="#7855ED" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </td>
            <td class="row-user">{{ user.userName }}</td>

            <td class="row-role">
              <div class="ds-dropdown"  [class.closed]="!open || (selectedUser.userId !== user.userId)">
                <div class="ds-header" (click)="toggleOpen(user)">
                  <span class="ds-title">
                    {{ user.userRole || 'Выберите роль' }}
                  </span>
                </div>
                <div class="ds-body">
                  <button *ngFor="let role of roles"
                          type="button"
                          class="chip"
                          [class.selected]="user.userRole === role.userRole"
                          (click)="onRoleChange(role.userRole, user)">
                    {{ role.userRole }}
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>
</main>
